export const BACKEND_URL = "usa.alto.exoware.xyz";
export const PUBLIC_KEY_HEX = "91845d7cb79f8bf50b4093864b1f83d0c8c94606645043c00b2d785af0a7223a83e9ad3fed54854fa05b5d070e41275904efa6f46b8bbeec2bd2619fa3ecba3b795054fb55072e84a1fd1894c2052fb9e88796bf470c9059907042af27607d51";
export const LOCATIONS: [[number, number], string][] = [
    [[38.8339, -77.3074], "Ashburn"],
    [[40.0946, -82.7541], "Columbus"],
    [[37.7749, -122.4194], "San Francisco"],
    [[45.9175, -119.2684], "Boardman"],
    [[38.8339, -77.3074], "Ashburn"],
    [[40.0946, -82.7541], "Columbus"],
    [[37.7749, -122.4194], "San Francisco"],
    [[45.9175, -119.2684], "Boardman"],
    [[38.8339, -77.3074], "Ashburn"],
    [[40.0946, -82.7541], "Columbus"],
    [[37.7749, -122.4194], "San Francisco"],
    [[45.9175, -119.2684], "Boardman"],
    [[38.8339, -77.3074], "Ashburn"],
    [[40.0946, -82.7541], "Columbus"],
    [[37.7749, -122.4194], "San Francisco"],
    [[45.9175, -119.2684], "Boardman"],
    [[38.8339, -77.3074], "Ashburn"],
    [[40.0946, -82.7541], "Columbus"],
    [[37.7749, -122.4194], "San Francisco"],
    [[45.9175, -119.2684], "Boardman"],
    [[38.8339, -77.3074], "Ashburn"],
    [[40.0946, -82.7541], "Columbus"],
    [[37.7749, -122.4194], "San Francisco"],
    [[45.9175, -119.2684], "Boardman"],
    [[38.8339, -77.3074], "Ashburn"],
    [[40.0946, -82.7541], "Columbus"],
    [[37.7749, -122.4194], "San Francisco"],
    [[45.9175, -119.2684], "Boardman"],
    [[38.8339, -77.3074], "Ashburn"],
    [[40.0946, -82.7541], "Columbus"],
    [[37.7749, -122.4194], "San Francisco"],
    [[45.9175, -119.2684], "Boardman"],
    [[38.8339, -77.3074], "Ashburn"],
    [[40.0946, -82.7541], "Columbus"],
    [[37.7749, -122.4194], "San Francisco"],
    [[45.9175, -119.2684], "Boardman"],
    [[38.8339, -77.3074], "Ashburn"],
    [[40.0946, -82.7541], "Columbus"],
    [[37.7749, -122.4194], "San Francisco"],
    [[45.9175, -119.2684], "Boardman"],
    [[38.8339, -77.3074], "Ashburn"],
    [[40.0946, -82.7541], "Columbus"],
    [[37.7749, -122.4194], "San Francisco"],
    [[45.9175, -119.2684], "Boardman"],
    [[38.8339, -77.3074], "Ashburn"],
    [[40.0946, -82.7541], "Columbus"],
    [[37.7749, -122.4194], "San Francisco"],
    [[45.9175, -119.2684], "Boardman"],
    [[38.8339, -77.3074], "Ashburn"],
    [[40.0946, -82.7541], "Columbus"]
];